<template>
  <login-layout class="view-password-reset">
    <v-overlay :value="formState.sending">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-card-text class="text-center">
      <h1 class="mb-6">Password reset</h1>
      <v-alert type="success" v-if="formState.success">
        A password reset link was sent. Click the link in the email to create a new password.
      </v-alert>
      <v-form @submit.prevent="submit" v-else>
        <v-alert type="error" v-if="formState.error.length">
          {{ formState.error }}
        </v-alert>
        <p>Please enter your email address.</p>
        <v-text-field
          v-model="login"
          label="E-mail"
          name="login"
          prepend-icon="person"
          type="email"
          color="primary darken-4"
          :error="!$v.login.required&&formState.validation"
          :error-messages="formState.validation?(!$v.login.required?'E-mail is required':!$v.login.email?'It must be a valid E-mail address':''):''"
          autofocus
        ></v-text-field>

        <v-btn large
               color="primary darken-4 white--text"
               :disabled="formState.sending"
               @click="submit">
          Reset password
        </v-btn>
      </v-form>
    </v-card-text>
  </login-layout>
</template>

<script>
    import { required, email } from 'vuelidate/lib/validators'

    export default {
        name: "PasswordReset",

        validations: {
            login: { required, email }
        },

        data() {
            return {
                login: '',
                formState: {
                    sending: false,
                    validation: false,
                    error: '',
                    success: false,
                },
            };
        },

        mounted() {
            this.$store.commit('loadingOff')
        },

        methods: {
            submit() {
                this.formState.validation = true;
                this.$v.login.$touch();

                if (this.$v.$invalid) {
                    this.formState.sending = false;
                } else {
                    this.formState.sending = true;
                    this.formState.error = '';

                    this.$sessionService.passwordReset(this.login)
                        .then(() => {
                            this.formState.success = true
                            setTimeout(()=>{this.$router.replace({ name: 'login' })}, 3000)
                        })
                        .catch((error) => {
                            this.formState.error = error.response.data.error;
                        }).finally(() => this.formState.sending = false);
                }
            }
        }
    }
</script>

<style scoped>

</style>
